import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { useEffect, useRef, useState } from 'react';
import { getCodigoDet } from '../../services/Roles/RolesService';

const CreaDet = ({ cabecera, onGuardar, detalle }) => {
    const [nombre, setNombre] = useState(detalle?.configuracionDetId ? detalle.nombre : '');
    const [codigoDet, setCodigoDet] = useState(detalle?.configuracionDetId ? detalle.codigo : '');
    const [parametro, setParametro] = useState(detalle?.configuracionDetId ? (detalle.parametro ? detalle.parametro : '') : '');
    const [activo, setActivo] = useState(detalle?.configuracionDetId ? detalle.activo : true);

    const [procesaGuardar, setProcesaGuardar] = useState(false);

    const toastDet = useRef();
    //console.log('ZZ0=', cabecera);
    useEffect(() => {
        const recuperaCodigoDet = async (codCabId, codInicial) => {
            try {
                const codigo = await getCodigoDet(codCabId, codInicial);
                setCodigoDet(codigo);
            } catch (err) {
                console.error('Error: ' + err.message);
            }
        };
        if (!detalle?.configuracionDetId) {
            recuperaCodigoDet(cabecera.configuracionCabId, cabecera.codigo);
        }
    }, []);

    const handleNombre = (evt) => {
        const nuevoValor = evt.target.value.toUpperCase();
        setNombre(nuevoValor);
    };

    const handleGuardar = () => {
        //
        if (!nombre) {
            toastDet.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe llenar Nombre' });
            return;
        }
        const formData = {
            detalleId: detalle?.configuracionDetId ? detalle?.configuracionDetId : 0,
            codigo: codigoDet,
            nombre: nombre,
            parametro: parametro,
            activo: activo
        };
        setProcesaGuardar(true);
        onGuardar(formData);
    };

    return (
        <div className="card">
            <h5>Creacion de Cabecera</h5>
            <Toast ref={toastDet} />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-4">
                    <label>Codigo Asignado</label>
                </div>
                <div className="field col-12 md:col-8">
                    <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">{codigoDet}</span>
                </div>
                <div className="field col-12 md:col-4">
                    <label>Nombre:</label>
                </div>
                <div className="field col-12 md:col-8">
                    <InputText value={nombre} maxLength={100} onInput={handleNombre} />
                </div>
                <div className="field col-12 md:col-4">
                    <label>Parametro:</label>
                </div>
                <div className="field col-12 md:col-8">
                    <InputTextarea value={parametro} onChange={(e) => setParametro(e.target.value)} rows={5} cols={30} />
                </div>
                <div className="field col-12 md:col-12">
                    <Checkbox inputId="chkActivo" checked={activo} onChange={(e) => setActivo(e.checked)} /> <label htmlFor="chkActivo">Activo</label>
                </div>
                <div className="field col-12 md:col-4">
                    <span>{''}</span>
                </div>
                <div className="field col-12 md:col-4">
                    <Button label="Guardar" onClick={handleGuardar} loading={procesaGuardar} />
                </div>
                <div className="field col-12 md:col-4">
                    <span>{''}</span>
                </div>
            </div>
        </div>
    );
};

export default CreaDet;
